import { useUserEventLogger } from '@repo/tracking-service';
import { TopNavigation } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import s from '@/components/my/common/layout.module.scss';

export const MyNotificationPageTopNavigation = () => {
  const { back } = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const goBack = () => {
    sendClickEvent('benefit-noti_topnav_back');
    back();
  };

  return <TopNavigation.Basic leftIcon={'back'} onLeftClick={goBack} className={s.nav_position} />;
};
